export default __webpack_public_path__ + "static/media/javascript-original.f719efab.svg";